"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextArea = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        box-shadow: 0 0 2px ", ";\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n            content: '*';\n            color: ", ";\n            position: absolute;\n            top: -2px;\n            margin-left: 2px;\n          "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      text-transform: none;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        margin-bottom: ", ";\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        margin-top: ", ";\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      margin-right: ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      margin-left: ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          width: ", ";\n          display: inline-block;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          width: 100%;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n\n  ", ";\n\n  ", ";\n    ", "\n    ", "\n  & .flexi-label-wrapper {\n    display: block;\n    position: absolute;\n    bottom: calc(100% + 8px);\n\n    & label {\n      text-transform: uppercase;\n      ", "\n      position: relative;\n      font-weight: 700;\n      display: block;\n      font-size: 0.9em;\n\n      &::after {\n        ", ";\n      }\n    }\n\n    & .desc {\n      font-weight: normal;\n      font-size: 0.8em;\n    }\n  }\n  & .flexi-text-area {\n    width: 100%;\n    min-height: ", ";\n    background-color: #fff;\n    padding: 10px;\n    font-family: inherit;\n    border: 1px solid ", ";\n    border-radius: ", ";\n    outline: none;\n    transition: ", ";\n    box-sizing: border-box;\n    resize: ", ";\n    color: ", ";\n    ", ";\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    &:focus {\n      border-color: ", ";\n      ", ";\n    }\n\n    &:disabled {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    &:disabled::placeholder {\n      color: ", ";\n    }\n  }\n  & .error {\n    color: ", ";\n    display: block;\n    margin-top: 4px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TextAreaWrapper = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var block = _ref.block,
      width = _ref.width;
  return block ? (0, _styledComponents.css)(_templateObject2()) : (0, _styledComponents.css)(_templateObject3(), width);
}, function (_ref2) {
  var spaceLeft = _ref2.spaceLeft;
  return spaceLeft && (0, _styledComponents.css)(_templateObject4(), spaceLeft.length >= 3 ? spaceLeft : '10px');
}, function (_ref3) {
  var spaceRight = _ref3.spaceRight;
  return spaceRight && (0, _styledComponents.css)(_templateObject5(), spaceRight.length >= 3 ? spaceRight : '10px');
}, function (props) {
  return props.spaceTop && (0, _styledComponents.css)(_templateObject6(), function (props) {
    return props.spaceTop.length >= 3 ? props.spaceTop : '20px';
  });
}, function (props) {
  return props.spaceBottom && (0, _styledComponents.css)(_templateObject7(), function (props) {
    return props.spaceBottom.length >= 3 ? props.spaceBottom : '25px';
  });
}, function (props) {
  return props.theme.noLabelUpperCase && (0, _styledComponents.css)(_templateObject8());
}, function (_ref4) {
  var required = _ref4.required,
      theme = _ref4.theme;
  return required && (0, _styledComponents.css)(_templateObject9(), theme.PrimaryRed);
}, function (_ref5) {
  var height = _ref5.height;
  return height;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.PrimaryBorderColor;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.PrimaryRadius;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.PrimaryTransition;
}, function (_ref9) {
  var resizeable = _ref9.resizeable;
  return resizeable ? 'both' : 'none';
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.PrimaryFontColor;
}, function (_ref11) {
  var error = _ref11.error,
      theme = _ref11.theme;
  return error && (0, _styledComponents.css)(_templateObject10(), theme.PrimaryRed, theme.PrimaryRed);
}, function (_ref12) {
  var theme = _ref12.theme;
  return (0, _polished.lighten)(0.3, theme.PrimaryFontColor);
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.PrimaryColor;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.Elevate.mid;
}, function (_ref15) {
  var theme = _ref15.theme;
  return (0, _polished.lighten)(0.1, theme.PrimaryGreyLight);
}, function (_ref16) {
  var theme = _ref16.theme;
  return (0, _polished.lighten)(0.2, theme.PrimaryInputOutline);
}, function (_ref17) {
  var theme = _ref17.theme;
  return (0, _polished.lighten)(0.3, theme.PrimaryFontColor);
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.PrimaryRed;
});

var TextArea = function TextArea(props) {
  var name = props.name,
      label = props.label,
      desc = props.desc,
      error = props.error,
      width = props.width,
      height = props.height,
      rest = _objectWithoutProperties(props, ["name", "label", "desc", "error", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement(TextAreaWrapper, props, label || desc ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-label-wrapper"
  }, label !== undefined && /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: name
  }, label), desc !== undefined && /*#__PURE__*/_react["default"].createElement("span", {
    className: "desc"
  }, desc)) : null, /*#__PURE__*/_react["default"].createElement("textarea", _extends({
    className: "flexi-text-area",
    placeholder: "Address"
  }, rest)), error && /*#__PURE__*/_react["default"].createElement("em", {
    className: "error"
  }, error));
};

exports.TextArea = TextArea;
TextArea.defaultProps = {
  width: '400px',
  height: '42px',
  resizeable: false
};
TextArea.propTypes = {
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].string,
  block: _propTypes["default"].bool,
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  desc: _propTypes["default"].string,
  error: _propTypes["default"].any,
  size: _propTypes["default"].any,
  spaceLeft: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  spaceRight: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  spaceTop: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  spaceBottom: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  disabled: _propTypes["default"].bool,
  resizeable: _propTypes["default"].bool,
  rows: _propTypes["default"].number
};